module.exports = __webpack_public_path__ + "static/media/option_d.b0855c81.png";